import React from 'react';
import { Pagination } from 'antd';
import './CustomPagination.css';

const CustomPagination = ({ 
  current, 
  total, 
  pageSize, 
  onChange, 
  onShowSizeChange,
  showSizeChanger = false,
  showQuickJumper = false,
  showTotal = true,
  size = 'default',
  className = '',
  ...props 
}) => {
  return (
    <div className={`custom-pagination-wrapper ${className}`}>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={showQuickJumper}
        showTotal={showTotal ? (total, range) => 
          `${range[0]}-${range[1]} sur ${total} éléments` : false
        }
        size={size}
        className="custom-pagination"
        {...props}
      />
    </div>
  );
};

export default CustomPagination;
